import axios from '../axios/axios'

export default {
  state: {
    loading: false,
    notification: null,
    lastEmployeesActionsSync: null
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading
    },
    setNotification(state, {type, text}) {
      state.notification = {type, text}
    },
    setLastEmployeesActionsSync(state, dateTime) {
      state.lastEmployeesActionsSync = dateTime
    }
  },
  actions: {
    async fetchAppInfo({commit}) {
      try {
        commit('setLoading', true)
        const response = await axios.get('/app-info')
        commit('setLastEmployeesActionsSync', response.data.appInfo.last_employee_actions_sync)
        commit('setLoading', false)
      } catch (e) {
        commit('setNotification', {type: 'error', text: e.response.data.message})
        commit('setLoading', false)
      }
    }
  },
  getters: {
    loading(state) {
      return state.loading
    },
    notification(state) {
      return state.notification
    },
    lastEmployeesActionsSync(state) {
      return state.lastEmployeesActionsSync
    }
  }
}
